import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2598de1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column content-error-page" }
const _hoisted_2 = { class: "mt-s6 h2" }
const _hoisted_3 = { class: "text-muted mt-s2" }

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { FULL_SELECTED_NETWORK_NAME } from '@/helpers/networkParams.helper';
import { ENABLE_FAKE_CARDANO_NETWORK } from '@/helpers/fakeCardanoNetwork';
import { WRAPPED_MILKOMEDA_CARDANO_NETWORK_NAME } from '@/constants/NETWORK_NAMES';
import Icon from '@/components/icon/Icon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FunctionalityNotSupported',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();

const currentRoute = router.currentRoute.value.name;

const selectedNet = computed(() => {
  return ENABLE_FAKE_CARDANO_NETWORK
    ? WRAPPED_MILKOMEDA_CARDANO_NETWORK_NAME
    : FULL_SELECTED_NETWORK_NAME;
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Icon, {
      name: "dangerOutline",
      size: "160",
      class: "align-self-center"
    }),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(`error.route.notSupported.${_unref(currentRoute)?.toString().toLowerCase()}`, { selectedNet: _unref(selectedNet) })), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('error.route.notSupported.weAreWorking')), 1),
    _createVNode(_component_Button, {
      class: "button-primary mt-s5 switch-page",
      label: _unref(t)('goToHome'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
    }, null, 8, ["label"])
  ]))
}
}

})